import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_cf_conversation_instance_events_RowClass } from "../../../dbschema";

export class BotCfConversationInstanceEventsContainerModel extends BaseContainerModel{
  alg_bot_cf_conversation_instance_events: alg_bot_cf_conversation_instance_events_RowClass = new alg_bot_cf_conversation_instance_events_RowClass();
}
